import React from 'react';
import './WorkflowOverview.css';
import ContinuousDiscovery from './ContinuousDiscovery';

function WorkflowOverview() {
  return (
    <div className="workflow-container">
      <div className="container">
        <ContinuousDiscovery />
      </div>
    </div>
  );
}

export default WorkflowOverview;
